module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Group-chat-11e78028f93431db66bf3e51bf09b2b4.svg";